import { Controller } from "@hotwired/stimulus"
import { get } from "@rails/request.js"

export default class extends Controller {
  static outlets = ["coreui-sidebar"]

  static values = { url: String, loaded: Boolean }

  click() {
    if (this.loadedValue) {
      this.coreuiSidebarOutlet.show()
    } else {
      get(this.urlValue).then((response) => {
        if (response.ok) {
          const result_text = response.text
          result_text.then((result) => {
            const el = this.coreuiSidebarOutlet.host
            el.innerHTML = result
            this.coreuiSidebarOutlet.show()
          })
        }
      })
      this.loadedValue = true
    }
  }
}
